import { setActiveTab } from 'utils/actions/active-tab/active-tab.actions';
import { checkAccess } from 'app/actions/app.actions';
import template from './messages-tab.html';
import tabs from './tabs';

const mapStateToThis = ({ session, ui }) => {
  const { isAdmin } = session;
  const { activeTab } = ui;
  const { INBOX, SENT } = tabs;

  return {
    activeTab,
    isAdmin,
    INBOX,
    SENT,
  };
};

const mapDispatchToThis = {
  setActiveTab,
  checkAccess,
};

// eslint-disable-next-line no-undef
@Inject('$ngRedux')
class MessagesTabController {
  constructor() {
    this.unsubscribe = this.$ngRedux.connect(mapStateToThis, mapDispatchToThis)(this);
  }

  $onInit() {
    this.initActiveTab();
  }

  $onDestroy() {
    this.setActiveTab('', 'activeTab');
    this.unsubscribe();
  }

  initActiveTab() {
    if (![this.INBOX, this.SENT].includes(this.activeTab)) {
      this.setActiveTab(this.INBOX, 'activeTab');
    }
  }
}

export default class MessagesTabComponent {
  constructor() {
    this.controller = MessagesTabController;
    this.template = template;
    return this;
  }
}



// WEBPACK FOOTER //
// ./src/modules/message/components/messages-tab/messages-tab-component.js